import React, { useState, useEffect, useRef, useMemo, } from "react";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { db } from "firebase/fbConfig.js";
import { Link } from 'react-router-dom';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import Fab from "@material-ui/core/Fab";

// @material-ui/icons
import Chat from '@material-ui/icons/Chat';
import AddIcon from "@material-ui/icons/Add";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import Style from "assets/jss/material-dashboard-pro-react/views/actionsStyle";

// Forms
import AddNewShipperProfileForm from "components/Forms/addNewShipperProfileForm.jsx"

// Firebase Redux Integration
import AddNewVendorProfileFormNew from "../../components/Forms/addNewVendorProfileFormNew";

const ExploreCard = props => {
    const { row, type } = props;
    const cityState = row.physicalCity ? (row.physicalState ? `${row.physicalCity}, ${row.physicalState}` : row.physicalCity) : (row.physicalState ? row.physicalState : null);
    const phoneEmail = row.mainPhone ? (row.email ? `${row.mainPhone} | ${row.email}` : row.mainPhone) : (row.email ? row.email : null);

    return (
        <Card style={{ backgroundColor: "#eee" }}>
            <Link style={{ width: "100%" }} to={{
                pathname: `/${type}/${row.id}`
            }}>
                <CardHeader>
                    <GridContainer>
                        <GridItem xs={9}>
                            <h5 style={{ color: "black", fontSize: ".9rem" }}>
                                <b>#{row.id}</b> <br />
                            </h5>
                        </GridItem>

                    </GridContainer>
                    <GridContainer>
                        <GridItem xs={12} md={4}>
                            <h4>
                                {row.name && (
                                    <React.Fragment>
                                        <b>{row.name}</b><br />
                                    </React.Fragment>
                                )}
                                {row.physicalAddress && (
                                    <React.Fragment>
                                        <b>{row.physicalAddress}</b><br />
                                    </React.Fragment>
                                )}
                                {cityState && (
                                    <React.Fragment>
                                        <b>{cityState}</b><br />
                                    </React.Fragment>
                                )}
                                {phoneEmail && (
                                    <React.Fragment>
                                        <b>{phoneEmail}</b><br />
                                    </React.Fragment>
                                )}
                            </h4>
                        </GridItem>
                        <GridItem xs={12} md={4}>
                            {row.airCodes && row.airCodes.map(code => {
                                return (
                                    <p>{code}
                                    </p>
                                )
                            })}
                        </GridItem>
                        <GridItem xs={12} md={2}>
                            {row.marketAreas && row.marketAreas.map(marketArea => {
                                return (
                                    <p>{marketArea}
                                    </p>
                                )
                            })}
                        </GridItem>
                        <GridItem xs={12} md={2}>
                            {type == "shipper" ?
                                <h4>
                                    <b>KSMS: {row.ksms ? "TRUE" : "FALSE"}</b>
                                </h4>
                                :
                                <h4>
                                    <b>TSA: {row.sta ? "TRUE" : "FALSE"}</b>
                                </h4>
                            }

                        </GridItem>
                    </GridContainer>

                    <GridContainer justify="center">
                        <GridItem xs={4}>
                            <Button
                                color="primary"
                                style={{
                                    backgroundColor: "#3f51b5",
                                    marginLeft: "10px",
                                    marginBottom: "10px"
                                }}
                            >
                                <b>View Profile</b>
                            </Button>
                        </GridItem>
                        <GridItem xs={4}>
                            <Link to={{
                                pathname: `/threads/${row.id}`,
                            }}>
                                <Button
                                    color="primary"
                                    style={{
                                        backgroundColor: "rgb(14, 178, 216)",
                                        marginLeft: "40px",
                                        marginBottom: "10px"
                                    }}
                                >
                                    <Chat />
                                </Button>
                            </Link>
                        </GridItem>
                        <GridItem xs={4}>
                            <Link to={{
                                pathname: `/wallet/${row.id}`,
                            }}>
                                <Button
                                    color="primary"
                                    style={{
                                        marginLeft: "10px",
                                        marginBottom: "10px"
                                    }}
                                >
                                    <img src="https://firebasestorage.googleapis.com/v0/b/cascadia-exchange.appspot.com/o/assets%2Ftreelight.png?alt=media&token=a84a68fe-7f0e-49c7-ac2d-cfb5695f9bec" style={{ maxWidth: "10px" }} />
                                </Button>
                            </Link>
                        </GridItem>
                    </GridContainer>
                </CardHeader>
            </Link>

        </Card>
    )
}

const Transition = (props) => {
    return <Slide direction="down" {...props} />
}

const Users = ({ path, query, ksms, classes }) => {
    const allDocs = useRef([]);
    const [forceRerender, setForceRerender] = useState(0);
    const [addNewVendorModal, setAddNewVendorModal] = useState(false);
    const filteredDocs = useMemo(() => {
        return allDocs.current.filter(doc => {
            const checks = ['id', 'name', 'city', 'state', 'vendorType', 'physicalCity'];
            const { marketAreas, airCodes } = doc;

            // Set up checking conditions for loop filter
            const lq = query.toLowerCase();

            if (ksms && !doc.ksms) return false;

            for (let i = 0; i < checks.length; i++) if (doc[checks[i]] && doc[checks[i]].toLowerCase().includes(lq)) return true;

            if (Array.isArray(marketAreas)) {
                for (let i = 0; i < marketAreas.length; i++) if (marketAreas[i].toLowerCase().includes(lq)) return true;
            }

            if (Array.isArray(airCodes)) {
                for (let i = 0; i < airCodes.length; i++) if (airCodes[i].toLowerCase().includes(lq)) return true;
            }

            return false;
        })
    }, [allDocs.current, query, ksms]);
    const type = path === 'haney-shippers' ? 'shipper' : 'vendor';

    const loadCollectionData = () => {
        db.collection(path).orderBy("name")
            .get().then((snapshot) => {
                return snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(data => {
                allDocs.current = data;
                setForceRerender(prev => prev + 1);
            })
    }

    useEffect(() => {
        if (allDocs.current.length) {
            allDocs.current = [];
            setForceRerender(prev => prev + 1);
        }
        loadCollectionData();
    }, [path]);

    return (
        <div>
            <div>
                <Button
                    color="danger"
                    onClick={() => setAddNewVendorModal(true)}
                >
                    ADD NEW {type == "shipper" ? "CUSTOMER" : "VENDOR"}
                </Button>

                {filteredDocs.map(row => <ExploreCard row={row} type={type} />)}

                <Dialog
                    open={addNewVendorModal}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => setAddNewVendorModal(false)}
                    aria-labelledby="shipment-modal-slide-title"
                    aria-describedby="shipment-modal-slide-description"
                >
                    <DialogContent
                        id="shipment-modal-slide-description"
                        className={classes.modalBody}
                    >
                        {/* FORM */}
                        {type == "shipper" ?
                            <AddNewShipperProfileForm
                                modalOpen={addNewVendorModal}
                            />
                            :
                            <AddNewVendorProfileFormNew
                                modalOpen={addNewVendorModal}
                            />
                        }


                        <Button
                            style={{
                                backgroundColor: "black",
                                marginLeft: "10px",
                                marginTop: "10px"
                            }}
                            key="close"
                            aria-label="Close"
                            onClick={() => setAddNewVendorModal(false)}
                        >
                            CLOSE
                        </Button>
                    </DialogContent>
                </Dialog>
                <Fab color="primary" aria-label="add" className={classes.fab} onClick={() => setAddNewVendorModal(true)}>
                    <AddIcon />
                </Fab>

            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {}
}

export default compose(
    connect(mapStateToProps),
    withStyles(Style)
)(Users);



// WEBPACK FOOTER //
// ./src/views/ExploreTemp/ExploreMap.jsx